import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export interface VerticalTabsUniDriver extends BaseUniDriver {}
